export default __webpack_public_path__ + "static/media/179.308daeb1.gif";